import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { PoliticaCreditoSegmento } from '../_models/politica-credito-segmento';

@Injectable({
  providedIn: 'root'
})
export class PoliticaCreditoSegmentoService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + '/api/politicasCreditosSegmentos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as PoliticaCreditoSegmento[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as PoliticaCreditoSegmento[] ) );
  }

  listadoPorPolitica( idPolitica: string ) {
    return this.httClient.get( this.rutServicio + '/politicaCredito/' + idPolitica ).pipe( map( res => res as PoliticaCreditoSegmento[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as PoliticaCreditoSegmento ) );
  }

  crear( regCrear: PoliticaCreditoSegmento ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as PoliticaCreditoSegmento ) );
  }

  actualizar( regActualizar: PoliticaCreditoSegmento ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: PoliticaCreditoSegmento[] ) {
    regActualizar.map( ( s: PoliticaCreditoSegmento ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }
}
